module.exports = __webpack_public_path__ + "media/checkmarks/green-checkmark-6b4a1636.svg";